export const addRolePermission = (payload: { role_id: number, permission_id: number }) => ({
    type: "@saga/ADD_ROLE_PERMISSION",
    payload
});